import { toast } from "react-toastify";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { server } from "../components/api";

const useTiko = () => {
  const router = useRouter();
  const TikoFormOnSubmit = async (values, paymentDetails, id) => {
    values.VirtualPosId = paymentDetails.VirtualPosId;
    values.price = paymentDetails.tutar;
    values.rez_no = paymentDetails.id;
    values.id = id;

    await CreatePaymentLink(
      localStorage.getItem("reservations_auth"),
      values
    ).then((e) => {
      if (e?.data?.conversationId) {
        router.push(
          process.env.NEXT_PUBLIC_API +
            "/Tiko/CreateForm?conversationId=" +
            e.data?.conversationId +
            "&rez_no=" +
            id
        );
      } else {
        toast.error(e.data.error);
      }
    });
  };

  const TikoInstallment = async (values) => {
    return await Installment(values).then((e) => e.data);
  };

  const CreatePaymentLink = async (token, formData) => {
    return server.post("/Tiko/CreateForm?token=" + token, formData);
  };

  const Installment = async (formData) => {
    return server.post("/Tiko/Installment", formData);
  };

  return {
    TikoFormOnSubmit,
    TikoInstallment,
  };
};

export default useTiko;
